import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["variant"];
import { jsx } from 'react/jsx-runtime';
import { ContentSwitchTab } from './content-switch-tab.js';
import { DefaultTab } from './default-tab.js';

var Tab = function Tab(props) {
  var _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      rest = _objectWithoutProperties(props, _excluded);

  return variant === 'contentSwitcher' ? jsx(ContentSwitchTab, _objectSpread({}, rest)) : jsx(DefaultTab, _objectSpread({}, rest));
};

export { Tab };